import { Component, Shark, Utils } from "shark-mvc";
import { Modal } from "bootstrap";

import templateContent from "./ai-tag-suggestion.html";
import "./style.css";

import waitBoxComponent from "../waitBox/waitBoxComponent";
import tagsComponent from "../tags/tagsComponent";

class AiTagSuggestionComponent extends Component {
	constructor () {
		super("aiTagSuggestionComponent");
		this.addTemplate("", templateContent);
	}

	afterRender () {
		this.modal = Modal.getOrCreateInstance(document.querySelector("#aiTagSuggestionModal"));
	}
	
	aiExtractTags () {
		const { currContent } = Shark.get();

		if (currContent) {
			// waitBoxComponent.open();

			const request = `Sei un redattore esperto, leggi il testo che ti passo e poi dimmi, secondo te, quali fra i seguenti TAG sarebbero adatti al testo che hai letto, scegli tutti quelli che ritieni coerenti col testo:
- Paesaggi
- Mare
- Animali
- Benessere
- Cibo
- Arte
- Storia
- Architettura
- Città
- Musica
- Cinema
- Shopping
- Intrattenimento
- Vita Notturna
- Celebrità
- Sport

Scegli solo i tag che ritieni pertinenti col testo e, solo per i tag che hai scelto, spiegami perché hai scelto ognuno.
Se non sai spiegare perché hai scelto un tag, allora non metterlo.
Inoltre estrai una lista di persone o personaggi famosi citati nel testo che abbiano pertinenza con il brano e che siano in qualche modo importanti per la storia raccontata.
Inoltre estrai una lista di luoghi che siano citati nel testo e che abbiano una certa importanza nel brano e che siano in qualche modo importanti per la storia raccontata.
Per ogni persona o personaggio o luogo che mi segnali, aggiungi una descrizione che spieghi per quale motivo lo hai incluso; se la motivazione non ti sembra sensata o non sai spiegarmi perché lo hai scelto, allora non metterlo.

Dammi solo le liste di risultati in JSON, non voglio altro contenuto.
Forniscimi i risultati in formato JSON rispettando il seguente modello:
{
	"tags":[
		{
			"value":"",
			"explanation":""
		}
	],
	"people":[
		{
			"value":"",
			"explanation":""
		}
	],
	"places":[
		{
			"value":"",
			"explanation":""
		}
	]
}
.`;
	
			if (true) {
				waitBoxComponent.open();

				fetch(`${Shark.$store.apiURL}/v2/ai/extract-tags`, {
					body: JSON.stringify({
						content: currContent.textBody,
						request,
					}),
					headers: {
						"Content-Type": "application/json",
					},
					method: "POST",
				})
				.then(response => response.json())
				.then(data => {
					console.log(data);
					const responseText = data.data.choices[0].message.content;
					// const aiSuggestions = responseText.split("\n").map(item => ({ value: item.trim().toLowerCase() })).filter(item => item.value !== "");
					// const aiSuggestions = responseText.split("\n").map(item => ({ value: item.replace("- ", "").trim().toLowerCase() })).filter(item => item.value !== "");
					const aiSuggestionsRaw = responseText.replace("```json", "").replace("```", "");
					const aiSuggestions = JSON.parse(aiSuggestionsRaw);

					// const aiSuggestedTags = responseText.split("-").map(item => ({ value: item.trim().toLowerCase() })).filter(item => item.value !== "");
					console.log({aiSuggestions});

					Shark.set({
						chatGPTResponseText: responseText,
					});

					waitBoxComponent.close();

					this.processChatGPTResponse(aiSuggestions);
				});
			}
			else {

				const data = {
					"id": "chatcmpl-A6yIAxD4vk9dhnJVtDhxjZbq4tGT8",
					"object": "chat.completion",
					"created": 1726225094,
					"model": "gpt-3.5-turbo-0125",
					"choices": [
						{
							"index": 0,
							"message": {
								"role": "assistant",
								"content": `TAG:
- Paesaggi: Il testo descrive dettagliatamente i paesaggi del Salento e delle coste pugliesi.
- Mare: Viene menzionato più volte il mare e la sua importanza nella zona descritta.
- Animali: Sono menzionati i rapaci e i gigli di mare presenti nell'oasi dei Laghi Alimini.
- Storia: Viene citata la disputa sul luogo di approdo di Enea e l'importanza storica dei luoghi descritti.
- Architettura: Si parla delle architetture di Santa Cesarea Terme.
- Città: Otranto e Santa Cesarea Terme sono menzionate come tappe della strada descritta.
- Musica: Non è pertinente al testo.
- Cinema: Non è pertinente al testo.
- Shopping: Non è pertinente al testo.
- Intrattenimento: Non è pertinente al testo.
- Vita Notturna: Non è pertinente al testo.
- Celebrità: Non è pertinente al testo.
- Sport: Non è pertinente al testo.

Persone o Personaggi:
- Guido Piovene
- Virgilio

Luoghi:
- Salento
- Laghi Alimini
- Punta Paliscia
- Porto Badisco
- Castro
- Otranto
- Grotta dei Cervi
- Zinzulusa
- Santa Cesarea Terme`,
								"refusal": null
							},
							"logprobs": null,
							"finish_reason": "stop"
						}
					],
					"usage": {
						"prompt_tokens": 1085,
						"completion_tokens": 124,
						"total_tokens": 1209,
						"completion_tokens_details": {
							"reasoning_tokens": 0
						}
					},
					"system_fingerprint": null
				};
				const responseText = data.choices[0].message.content;
				const aiSuggestions = responseText.split("\n").map(item => ({ value: item.replace("- ", "").trim().toLowerCase() })).filter(item => item.value !== "");
				console.log({aiSuggestions});

				this.processChatGPTResponse(aiSuggestions);


			}
		}
	}

	aiExtractTagsBtn_clickHandler () {
		this.aiExtractTags();
	}

	aiTagSuggestionModalCancelBtn_clickHandler () {
		// Dave: chiediamo una conferma?
		this.close();
	}
	
	aiTagSuggestionModalAcceptBtn_clickHandler () {
		const { aiSuggestedFullList, aiTagSuggestionData, currContent } = Shark.get();

		if (currContent) {
			const tagToAdd = aiSuggestedFullList
			.filter(item => aiTagSuggestionData.processingTagList.includes(item._index))
			.map(item => ({ source: "auto-ai", type: item.type, value: item.value.toLowerCase() }));

			tagsComponent.tagify.addTags(tagToAdd);
			console.log({currContent, tagToAdd});

			setTimeout(() => {
				this.close();
			}, 200);
		}
	}

	aiTagSuggestionModalCopyDebugInfoBtn_clickHandler () {
		const { chatGPTResponseText } = Shark.get();

		navigator.clipboard.writeText(chatGPTResponseText);
	}

	close () {
		this?.modal?.hide();
	}
	
	hiliteTag_mouseoutHandler () {
		document.querySelectorAll(".hilite-for-over").forEach(item => item.classList.remove("hilite-for-over"));
	}
	
	hiliteTag_mouseoverHandler (event, data) {
		const referenceContent = data.hiliteValue;

		if (referenceContent) {
			document.querySelectorAll(".hilite-for-over").forEach(item => item.classList.remove("hilite-for-over"));
			document.querySelectorAll(`.badge[data-tag-index="${referenceContent}"]`).forEach(item => item.classList.add("hilite-for-over"));
		}
	}

	init () {
		this.addComponents([waitBoxComponent]);

		const aiTagSuggestionData = Shark.getInstance("__smart__", {
			processingTagList: [],
			onDataChanged: (data) => console.log(data),
		});

		Shark.set({
			aiTagSuggestionData,
		});
	}
	
	open () {
		this?.modal?.show();
	}

	processChatGPTResponse (aiSuggestions) {
		waitBoxComponent.open();

		const { aiTagSuggestionData, currContent } = Shark.get();

		const aiSuggestedTags = aiSuggestions.tags;
		const aiSuggestedPeople = aiSuggestions.people;//.map(value => ({ value }));
		const aiSuggestedPlaces = aiSuggestions.places;//.map(value => ({ value }));
		const aiSuggestedFullList = [...aiSuggestedTags, ...aiSuggestedPeople, ...aiSuggestedPlaces];
		let destList = aiSuggestedTags;

		// aiSuggestions.forEach(item => {
		// 	if (item.value.toLowerCase() === "tag selezionati:" || item.value.toLowerCase() === "tag che utilizzerei:" || item.value.toLowerCase() === "tag coerenti con il testo:" || item.value.toLowerCase().includes("tag:") || item.value.toLowerCase().includes("tags:")) {
		// 		console.log("passo alla lista tag", item);
		// 		destList = aiSuggestedTags;
		// 	}
		// 	else if (item.value.toLowerCase() === "persone o personaggi menzionati nel testo:" || item.value.toLowerCase() === "persone o personaggi citati nel testo:" || item.value.toLowerCase().includes("persone:") || item.value.toLowerCase().includes("personaggi:")) {
		// 		console.log("passo alla lista persone", item);
		// 		destList = aiSuggestedPeople;
		// 	}
		// 	else if (item.value.toLowerCase() === "luoghi citati nel testo:" || item.value.toLowerCase().includes("luoghi:")) {
		// 		console.log("passo alla lista luoghi", item);
		// 		destList = aiSuggestedPlaces;
		// 	}
		// 	else {
		// 		destList.push(item);
		// 		aiSuggestedFullList.push(item);
		// 	}
		// });

		currContent.__taggedBody = currContent.body;

		Utils.reindexList(aiSuggestedFullList);

		aiSuggestedPeople.sort((a, b) => b.value.length - a.value.length);
		aiSuggestedPlaces.sort((a, b) => b.value.length - a.value.length);
		
		aiSuggestedPeople.forEach(item => {
			const key = item.value.replace("'", "&rsquo;");
			const regex = new RegExp(key, "gi");
			currContent.__taggedBody = currContent.__taggedBody.replace(regex, `<span class="badge bg-success p-1" data-tag-index="${item._index}">$&</span>`);
			item.type = "person";
			item.occurenceCount = currContent.__taggedBody.match(regex)?.length || 0;
			item.reasonWhy = item.explanation;
		});

		aiSuggestedPlaces.forEach(item => {
			const key = item.value.replace("'", "&rsquo;");
			const regex = new RegExp(key, "gi");
			currContent.__taggedBody = currContent.__taggedBody.replace(regex, `<span class="badge bg-warning p-1 text-dark" data-tag-index="${item._index}">$&</span>`);
			item.type = "place";
			item.occurenceCount = currContent.__taggedBody.match(regex)?.length || 0;
			item.reasonWhy = item.explanation;
		});

		aiSuggestedTags.forEach(item => {
			const key = item.value.replace("'", "&rsquo;");
			const regex = new RegExp(key, "gi");
			currContent.__taggedBody = currContent.__taggedBody.replace(regex, `<span class="badge bg-primary p-1" data-tag-index="${item._index}">$&</span>`);
			item.type = "theme";
			item.occurenceCount = currContent.__taggedBody.match(regex)?.length || 0;
			item.reasonWhy = item.explanation;
		});

		aiSuggestedTags.sort((a, b) => a.value > b.value ? 1 : -1);
		aiSuggestedPeople.sort((a, b) => a.value > b.value ? 1 : -1);
		aiSuggestedPlaces.sort((a, b) => a.value > b.value ? 1 : -1);
		
		aiTagSuggestionData.set({
			processingTagList: aiSuggestedFullList.map(item => item._index),
		});

		Shark.set({
			aiSuggestedTags,
			aiSuggestedPeople,
			aiSuggestedPlaces,
			aiSuggestedFullList,
			aiTagSuggestionData,
		});

		// console.log({
		// 	aiSuggestedFullList,
		// 	aiSuggestedTags,
		// 	aiSuggestedPeople,
		// 	aiSuggestedPlaces,
		// 	aiTagSuggestionData,
		// });
		
		waitBoxComponent.close();

		setTimeout(() => {
			this.open();
		}, 250);
	}

	selectAllBtn_clickHandler (event, data) {
		const target = data.target;
		const { aiSuggestedPeople, aiSuggestedPlaces, aiSuggestedTags, aiTagSuggestionData } = Shark.get();
		
		let processingTagList = aiTagSuggestionData.processingTagList;

		switch (target) {
			case "people":
				aiSuggestedPeople.forEach(item => processingTagList.push(item._index));
				break;
			case "places":
				aiSuggestedPlaces.forEach(item => processingTagList.push(item._index));
				break;
			case "tags":
				aiSuggestedTags.forEach(item => processingTagList.push(item._index));
				break;
		}
		
		aiTagSuggestionData.set({
			processingTagList: Array.from(new Set(processingTagList)),
		});
		
		Shark.render();

	}

	selectNoneBtn_clickHandler (event, data) {
		const target = data.target;
		const { aiSuggestedPeople, aiSuggestedPlaces, aiSuggestedTags, aiTagSuggestionData } = Shark.get();
		
		let processingTagList = aiTagSuggestionData.processingTagList;

		switch (target) {
			case "people":
				aiSuggestedPeople.forEach(item => processingTagList.splice(processingTagList.indexOf(item._index), 1));
				break;
			case "places":
				aiSuggestedPlaces.forEach(item => processingTagList.splice(processingTagList.indexOf(item._index), 1));
				break;
			case "tags":
				aiSuggestedTags.forEach(item => processingTagList.splice(processingTagList.indexOf(item._index), 1));
				break;
		}
		
		aiTagSuggestionData.set({
			processingTagList,
		});
		
		Shark.render();
	}
}

const aiTagSuggestionComponent = new AiTagSuggestionComponent();

Shark.registerComponent(aiTagSuggestionComponent);

export default aiTagSuggestionComponent;
